<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :form="form" :rules="rules" class='m-t-80' :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-item ref="ssl_cer" label="证书" name="ssl_cer">
          <a-textarea v-model:value='form.ssl_cer' :rows="4" />
        </a-form-item>
        <a-form-item ref="ssl_key" label="证书KEY" name="ssl_key">
          <a-textarea v-model:value='form.ssl_key' :rows="4" />
        </a-form-item>
        <a-form-item ref="app_id" label="APPID" name="app_id" help='(公众号应用ID）'>
          <a-input v-model:value='form.app_id' />
        </a-form-item>
        <a-form-item ref="mch_id" label="商户号" name="mch_id" help='(申请微信支付的邮件中获取）'>
          <a-input v-model:value='form.mch_id' />
        </a-form-item>
        <a-form-item ref="mch_key" label="支付KEY" name="mch_key" help='(32位的API密钥）'>
          <a-input v-model:value='form.mch_key' />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" class='m-t-90'>
          <a-button type="primary" v-has:wechatInterfaceSet="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getWx_config, setWx_config } from '@/api/public_wx';
  let defForm = {
    ssl_cer: '',
    ssl_key: '',
    mch_key: '',
    mch_id: '',
    app_id: ''
  };
  export default {
    setup(props, ctx) {
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 3 },
        wrapperCol: { span: 12 },
        rules: {
          ssl_cer: [
            { required: true, message: "证书不能为空" }
          ],
          ssl_key:[
            { required: true, message: "证书KEY不能为空" }
          ],
          app_id:[
            { required: true, message: "APPID不能为空" }
          ],
          mch_id:[
            { required: true, message: "商户号不能为空" }
          ],
          mch_key:[
            { required: true, message: "支付KEY不能为空" }
          ]
        },
      });
      const getConfig = async() =>{
        const hide = message.loading('正在加载中...', 0);
        let res = await getWx_config().then(res => res.data);
        if (iscode(res)) {
          setTimeout(hide);
          form.value = res.data
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }
      const ruleForm = ref();
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading('正在加载中...', 0);
          let res = await setWx_config(form.value).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch((error) => {
          console.log("error", error);
        });
      };
      onMounted(() => {
        getConfig();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      };
    },
  };
</script>